import { render, staticRenderFns } from "./TraplinkedNotifications.vue?vue&type=template&id=51c0fa05"
import script from "./TraplinkedNotifications.vue?vue&type=script&lang=js"
export * from "./TraplinkedNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports